export const TITLE_ASC = 'title-low-to-high';
export const TITLE_DESC = 'title-high-to-low';
export const PRICE_ASC = 'price-low-to-high';
export const PRICE_DESC = 'price-high-to-low';
